import { BronzeView } from './bronze';

export function BronzeScreen() {
  return (
    <div className="h-full w-full overflow-y-auto p-4 md:p-6">
      <BronzeView />
    </div>
  );
}
